import React from 'react'
import PreviousButton from 'components/PreviousButton'
import NextButton from 'components/NextButton'
import scrollToDivByIdDomUtil from 'containers/QuickShopProductSidebar/components/Reviews/utils/scroll-to-div-by-id'

const MAX_PAGES_TO_SHOW = 3

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange
}) => {
  if (totalPages < 2) {
    return
  }

  const getPageNumbers = () => {
    const pages = []

    if (totalPages <= MAX_PAGES_TO_SHOW) {
      // If total pages are less than or equal to maxPagesToShow, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      // Show pages with a limit of maxPagesToShow, ensuring currentPage is centered
      const startPage = Math.max(1, currentPage - Math.floor(MAX_PAGES_TO_SHOW / 2))
      const endPage = Math.min(totalPages, startPage + MAX_PAGES_TO_SHOW - 1)

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }
    }

    return pages
  }

  return (
    <div className='jdgm-paginate'>
      {currentPage > 1 &&
        <PreviousButton onClick={() => {
          scrollToDivByIdDomUtil('quick-shop-reviews', 'up')
          onPageChange(currentPage - 1)
        }}
        />}

      {getPageNumbers().map((pageNumber) => (
        <button
          key={pageNumber}
          className={pageNumber === currentPage ? 'jgm-review-pagination-number-buttons-active' : 'jgm-review-pagination-number-buttons'}
          onClick={() => {
            scrollToDivByIdDomUtil('quick-shop-reviews', 'up')
            onPageChange(pageNumber)
          }}
        >
          {pageNumber}
        </button>
      ))}

      {currentPage < totalPages &&
        <NextButton onClick={() => {
          scrollToDivByIdDomUtil('quick-shop-reviews', 'up')
          onPageChange(currentPage + 1)
        }}
        />}

    </div>
  )
}

export default Pagination
